/* eslint-disable no-restricted-imports */
import React, { Suspense } from 'react';
import type { VirtuosoGridProps, VirtuosoHandle } from 'react-virtuoso';

import Loader from '@/components/Loader';

const LazyVirtuosoGrid = React.lazy(() => {
  return import(/* webpackChunkName: "react-virtuoso" */ 'react-virtuoso').then((exports) => {
    return { default: exports.VirtuosoGrid };
  });
});

const VirtualizedGrid = React.forwardRef(
  (props: VirtuosoGridProps<any>, ref: React.Ref<VirtuosoHandle>) => {
    return (
      <Suspense fallback={<Loader />}>
        <LazyVirtuosoGrid ref={ref} {...props} />
      </Suspense>
    );
  },
);

export default VirtualizedGrid;
